// Libs
import React, { useState } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { Box, Radio, Checkbox, Typography, useMediaQuery } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";

// App
export const StepViewContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;

    color: ${theme.palette.common.white};
    background-color: ${theme.palette.hightownGreen.main};
    padding: 0px 20px;
    margin: 7px 0px;

    > p {
        margin: 8px 0px;
    }

    @media (max-width: 768px) {
        height: 48px;
    }
`;

export interface IProps {
    stepNumber: number;
    style?: object;
}

export const StepView: React.FC<IProps> = (props: IProps = { stepNumber: 1 }) => {
    const isMobile = useMediaQuery("(max-width: 767px)") ? true : false;
    return useObserver(() => (
        <>
            <StepViewContainer style={props.style}>
                <Typography style={isMobile ? { fontSize: "16px" } : {}}>Step {props.stepNumber}</Typography>
            </StepViewContainer>
        </>
    ));
};
